<template>
    <div class="inspection-page">
      <div class="left-form" ref="madeForm">
        <avue-form ref="AvueForm" :option="formOption" v-model="detailForm" @submit="submit"></avue-form>
        <div class="storage-point-section">
          <div class="section-title">
            <span>物资扣减明细</span>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addDeductionItem">添加物资</el-button>
          </div>
          <el-table :data="deductionExtList" border style="width: 100%" v-if="deductionExtList.length > 0">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="物资" prop="materialName" min-width="200">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.materialCode"
                  placeholder="请选择物资"
                  filterable
                  style="width: 100%"
                  @change="handleMaterialSelectChange(scope.row, $event)"
                >
                  <el-option
                    v-for="item in materialOptions"
                    :key="item.materialCode"
                    :label="`${item.materialName} (${item.materialCode})`"
                    :value="item.materialCode"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="物资名称" prop="materialName" min-width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.materialName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="物资类型" prop="materialType" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.materialType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="储备点" prop="storagePointName" min-width="200">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.storagePointId"
                  placeholder="请选择储备点"
                  filterable
                  style="width: 100%"
                  @change="handleStoragePointChange(scope.row, $event)"
                >
                  <el-option
                    v-for="item in availableStoragePointOptions(scope.row)"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="当前库存" prop="currentStock" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.currentStock || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="扣减数量" prop="deductionQuantity" width="150">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.deductionQuantity"
                  :min="1"
                  :max="999999"
                  :precision="0"
                  style="width: 100%"
                  @change="calculateTotalQuantity"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="单位" prop="unit" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.unit || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="width:3em;"  icon="el-icon-delete" @click="removeDeductionItem(scope.$index)">
                    删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="empty-tip">请添加至少一个物资扣减明细</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { disposeDetail, rulesInput } from '@/basic-common/util/common.js';
  import { getList as getMaterialList, getDetail as getMaterialDetail } from '../api';
  import { getList as getStoragePointList } from '../../reserve-point/api';
  import { add, update, getDetail } from '../../material-deduction-form/api';
  
  export default {
    data () {
      return {
        detailForm: {
          deductionType: 0, // 默认损耗
          purposeDesc: '',
          applicationId: '',
          applicationNo: '',
          totalQuantity: 0,
          remark: ''
        },
        deductionExtList: [],
        storagePointOptions: [],
        materialStorageOptions: [],
        materialOptions: [],
        materialColumn:[],
        currentMaterial: null,
        isEdit: false, // 是否为编辑模式
        editId: null, // 编辑时的ID
        formOption: {
          ...this.$store.state.formOption,
          menu: false,
          span: 24,
          submitBtn: true,
          emptyBtn: true,
          edit: true,
          column: [
            {
              label: '类型',
              prop: 'deductionType',
              type: 'select',
              dicData: [
                { label: '损耗', value: 0 },
                { label: '更换', value: 1 },
              ],
              placeholder: '请选择类型',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '用途说明',
              prop: 'purposeDesc',
              type: 'input',
              maxlength: 200,
              placeholder: '请输入用途说明',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '关联申请单号',
              prop: 'applicationNo',
              type: 'select',
              dicData: [],
              placeholder: '请选择关联申请单号',
              display: false,
              span: 12,
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: '关联申请单ID',
              prop: 'applicationId',
              type: 'number',
              placeholder: '自动填充',
              disabled: true,
              display: false,
              span: 12,
            },
            {
              label: '总数量',
              prop: 'totalQuantity',
              type: 'number',
              precision: 0,
              min: 0,
              disabled: true,
              span: 12,
            },
            {
              label: '备注',
              prop: 'remark',
              type: 'textarea',
              maxlength: 500,
              rows: 4,
              placeholder: '请输入备注',
              span: 24,
            },
          ],
        },
      };
    },
    mounted () {
      this.init();
      this.loadMaterialOptions();
      this.loadStoragePointOptions();
    },
    methods: {
      init () {
        disposeDetail(this.$refs.madeForm);
      },
      // 加载物资选项
      async loadMaterialOptions () {
        try {
          const res = await getMaterialList({
            page: 1,
            size: 1000,
            status: 1, // 只获取有效的物资
          });
          if (res.data && res.data.data && res.data.data.records) {
            this.materialOptions = res.data.data.records;
            this.materialColumn = this.formOption.column.find(col => col.prop === 'materialCode');
            if (this.materialColumn) {
              this.materialColumn.dicData = this.materialOptions.map(item => ({
                label: `${item.materialName} (${item.materialCode})`,
                value: item.materialCode,
                ...item
              }));
            }
          }
        } catch (error) {
          console.error('加载物资列表失败:', error);
          this.$message.error('加载物资列表失败');
        }
      },
      // 加载储备点选项
      async loadStoragePointOptions () {
        try {
          const res = await getStoragePointList({
            page: 1,
            size: 1000,
            status: 1, // 只获取有效的储备点
          });
          if (res.data && res.data.data && res.data.data.records) {
            this.storagePointOptions = res.data.data.records.map(item => ({
              id: item.id,
              pointName: item.pointName,
            }));
          }
        } catch (error) {
          console.error('加载储备点列表失败:', error);
          this.$message.error('加载储备点列表失败');
        }
      },
      // 处理物资选择变化
      async handleMaterialSelectChange (row, materialCode) {
        const material = this.materialOptions.find(item => item.materialCode === materialCode);
        if (material) {
          const storageOptions = await this.loadMaterialStorageOptions(material);
          row.materialName = material.materialName;
          row.materialType = material.materialType;
          row.unit = material.unit || '';
          row.storagePointId = '';
          row.storagePointName = '';
          row.currentStock = 0;
          row.storageOptions = storageOptions;
        }
      },
      async initMaterial (material) {
        this.resetForm();
        if (!material) {
          return;
        }
        this.currentMaterial = { ...material };
        this.materialStorageOptions = await this.loadMaterialStorageOptions(material);
        this.deductionExtList = [this.buildDeductionItem(this.currentMaterial, this.materialStorageOptions)];
        this.calculateTotalQuantity();
      },
      buildDeductionItem (material, storageOptions) {
        return {
          materialCode: material.materialCode || '',
          materialName: material.materialName || '',
          materialType: material.materialType || '',
          storagePointId: '',
          storagePointName: '',
          currentStock: 0,
          deductionQuantity: 1,
          unit: material.unit || '',
          storageOptions: storageOptions || [],
          remark: '',
        };
      },
      async loadMaterialStorageOptions (material) {
        if (!material || !material.id) {
          return [];
        }
        try {
          const res = await getMaterialDetail(material.id);
          const detail = (res.data && res.data.data) || {};
          return (detail.extList || []).map(item => ({
            id: item.storagePointId,
            pointName: item.storagePointName || item.pointName || item.storagePointId,
            currentStock: item.currentStock || 0,
          })).filter(item => item.id);
        } catch (error) {
          console.error('加载物资储备点库存失败:', error);
          this.$message.error('加载物资储备点库存失败');
          return [];
        }
      },
      availableStoragePointOptions (row) {
        if (row && row.storageOptions && row.storageOptions.length > 0) {
          return row.storageOptions;
        }
        if (this.materialStorageOptions.length > 0) {
          return this.materialStorageOptions;
        }
        return this.storagePointOptions;
      },
      // 添加扣减明细项
      addDeductionItem () {
        if (this.currentMaterial) {
          this.deductionExtList.push(this.buildDeductionItem(this.currentMaterial, this.materialStorageOptions));
          return;
        }
        this.deductionExtList.push(this.buildDeductionItem({}, []));
      },
      // 移除扣减明细项
      removeDeductionItem (index) {
        this.deductionExtList.splice(index, 1);
        this.calculateTotalQuantity();
      },
      // 处理储备点选择变化
      handleStoragePointChange (row, storagePointId) {
        const storagePoint = this.availableStoragePointOptions(row).find(item => item.id === storagePointId);
        if (storagePoint) {
          row.storagePointName = storagePoint.pointName;
          row.currentStock = storagePoint.currentStock || 0;
        }
      },
      // 计算总数量
      calculateTotalQuantity () {
        const total = this.deductionExtList.reduce((sum, item) => {
          return sum + (Number(item.deductionQuantity) || 0);
        }, 0);
        this.detailForm.totalQuantity = total;
      },
      // 提交表单
      toSubmit(){
        this.$refs.AvueForm.submit(); // 触发提交
      },
      submit (form, done) {
        this.$refs.AvueForm.validate((valid) => {
          if (!valid) {
            done();
            return false;
          }
          
          // 验证扣减明细信息
          if (!this.deductionExtList || this.deductionExtList.length === 0) {
            this.$message.warning('请至少添加一个物资扣减明细');
            done();
            return false;
          }
  
          // 验证扣减明细信息完整性
          for (let i = 0; i < this.deductionExtList.length; i++) {
            const item = this.deductionExtList[i];
            if (!item.materialCode) {
              this.$message.warning(`请选择第${i + 1}个明细项的物资`);
              done();
              return false;
            }
            if (!item.storagePointId) {
              this.$message.warning(`请选择第${i + 1}个明细项的储备点`);
              done();
              return false;
            }
            if (!item.deductionQuantity || item.deductionQuantity <= 0) {
              this.$message.warning(`请输入第${i + 1}个明细项的扣减数量`);
              done();
              return false;
            }
            if (Number(item.deductionQuantity) > Number(item.currentStock || 0)) {
              this.$message.warning(`第${i + 1}个明细项扣减数量不能大于当前库存`);
              done();
              return false;
            }
            const duplicate = this.deductionExtList.findIndex((row, index) => {
              return index !== i && row.materialCode === item.materialCode && String(row.storagePointId) === String(item.storagePointId);
            });
            if (duplicate > -1) {
              this.$message.warning(`第${i + 1}个明细项与第${duplicate + 1}个明细项物资和储备点重复`);
              done();
              return false;
            }
          }
  
          // 自动计算总数量
          this.calculateTotalQuantity();
  
          // 构建提交数据
          const submitData = {
            ...this.detailForm,
            materialDeductionExtList: this.deductionExtList.map(item => ({
              materialCode: item.materialCode,
              materialName: item.materialName,
              materialType: item.materialType,
              storagePointId: item.storagePointId,
              storagePointName: item.storagePointName,
              currentStock: item.currentStock || 0,
              deductionQuantity: item.deductionQuantity,
              unit: item.unit || '',
              remark: item.remark || '',
            })),
          };
          delete submitData.applicationId;
          delete submitData.applicationNo;
          
          // 如果是编辑模式，添加ID
          if (this.isEdit && this.editId) {
            submitData.id = this.editId;
          }
  
          // 调用接口提交
          const apiMethod = this.isEdit ? update : add;
          apiMethod(submitData).then((res) => {
            if (res.data && res.data.code === 200) {
              this.$message.success(this.isEdit ? '更新成功' : '新增成功');
              this.resetForm();
              done();
              this.$emit('success');
            } else {
              this.$message.error((res.data && res.data.msg) || '操作失败');
              done();
            }
          }).catch((error) => {
            console.error('提交失败:', error);
            this.$message.error((error.response && error.response.data && error.response.data.msg) || '操作失败，请稍后重试');
            done();
          });
        });
      },
      // 重置表单
      resetForm () {
        this.$refs.AvueForm.resetForm();
        this.detailForm = {
          deductionType: 0,
          purposeDesc: '',
          applicationId: '',
          applicationNo: '',
          totalQuantity: 0,
          remark: ''
        };
        this.deductionExtList = [];
        this.materialStorageOptions = [];
        this.currentMaterial = null;
        this.isEdit = false;
        this.editId = null;
      },
      // 编辑时加载数据
      async loadEditData (id) {
        try {
          const res = await getDetail(id);
          if (res.data && res.data.data) {
            const data = res.data.data;
            this.editId = data.id;
            this.isEdit = true;
            this.detailForm = {
              deductionType: data.deductionType !== undefined ? data.deductionType : 0,
              purposeDesc: data.purposeDesc || '',
              applicationId: data.applicationId || '',
              applicationNo: data.applicationNo || '',
              totalQuantity: data.totalQuantity || 0,
              remark: data.remark || ''
            };
            // 加载子表数据
            if (data.materialDeductionExtList && data.materialDeductionExtList.length > 0) {
              this.deductionExtList = data.materialDeductionExtList.map(item => ({
                id: item.id,
                materialCode: item.materialCode || '',
                materialName: item.materialName || '',
                materialType: item.materialType || '',
                storagePointId: item.storagePointId || '',
                storagePointName: item.storagePointName || '',
                currentStock: item.currentStock || 0,
                deductionQuantity: item.deductionQuantity || 0,
                unit: item.unit || '',
                remark: item.remark || '',
              }));
            }
          }
        } catch (error) {
          console.error('加载数据失败:', error);
          this.$message.error('加载数据失败');
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-form__menu {
    display: none;
  }
  .inspection-page {
    display: flex;
    padding: 20px;
    gap: 20px;
    background-color: #fff;
  }
  .left-form {
    flex: 1;
  }
  .storage-point-section {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
  }
  .empty-tip {
    text-align: center;
    color: #909399;
    padding: 40px 0;
  }
  </style>
